// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgressBar_container__ifUFc","guide":"ProgressBar_guide__fnnzi","gauge":"ProgressBar_gauge__o3ZRB","completed":"ProgressBar_completed__VA3CF"};